import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import { RouterProvider } from "react-router";

import { AuthProvider } from "@providers/AuthProvider/AuthProvider";
import { MainLayoutProvider } from "@providers/MainLayoutProvider/MainLayoutProvider";
import { NotificationProvider } from "@providers/NotificationProvider/NotificationProvider";
import { persister, queryClient } from "@providers/QueryClient/queryClient";
import { ThemeProvider } from "@providers/ThemeProvider/ThemeProvider";

import { EnvironmentBanner } from "@components/EnvironmentBanner";
import { ImpersonationBanner } from "@components/ImpersonationBanner/ImpersonationBanner";

import { router } from "@pages/Router";

import "reset-css/reset.css";

TimeAgo.addDefaultLocale(en);

function App() {
  return (
    <>
      <EnvironmentBanner />
      <ImpersonationBanner />
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{
          persister,
        }}
      >
        <ThemeProvider>
          <MainLayoutProvider>
            <AuthProvider>
              <NotificationProvider>
                <RouterProvider router={router} />
              </NotificationProvider>
            </AuthProvider>
          </MainLayoutProvider>
        </ThemeProvider>
      </PersistQueryClientProvider>
    </>
  );
}

export default App;
